import React from 'react'
import darkLogo from '../assets/logo-dark.svg'
import whiteLogo from '../assets/Noveliatech - Logo - White.svg'
import logoWhiteSymbol from "../assets/Noveliatech - Symbol - White.svg"
import { Link } from 'react-router-dom'

const Logo = ({ isWhite , size = "md",      // "sm" | "md" | "lg"
  showSymbolOnMobile = true,
  className = "",
 }) => {

  const sizes = {
    sm: { main: "220px", symbol: "30px" },
    md: { main: "260px", symbol: "40px" },
    lg: { main: "300px", symbol: "50px" },
  };
  return (
     <Link to="/" className={`text-decoration-none ${className}`}>
      {isWhite ? (
        <>
          {/* Desktop logo */}
          <img
            src={whiteLogo}
            alt="Company logo"
            style={{ width: sizes[size].main }}
            className="d-none d-lg-inline-block"
          />

          {/* Mobile symbol */}
          {showSymbolOnMobile && (
            <img
              src={logoWhiteSymbol}
              alt="Company symbol"
              style={{ width: sizes[size].symbol }}
              className="d-inline-block d-lg-none"
            />
          )}
        </>
      ) : (
        <img
          src={darkLogo}
          alt="Company logo"
          style={{ width: sizes[size].main }}
        />
      )}
    </Link>
  )
}
export default Logo
